import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { useSelector } from "react-redux";

import appRoutes from "constants/routeConstants";

import Login from "components/features/Forms/Login";
import Dashboard from "components/Dashboard";
import Error404 from "components/Error404";

function AppRoutes() {
	const user = useSelector((state) => state.user);
	return (
		<Router>
			{user && user.token ? (
				<Dashboard />
			) : (
				<Switch>
					<Route exact path="/" component={Login} />
					<Route path={appRoutes.INDEX} exact component={Login} />
					<Route path={appRoutes.LOGIN} exact component={Login} />
					<Route path="/**">
						<Error404 />
					</Route>
				</Switch>
			)}
		</Router>
	);
}

export default AppRoutes;
